module.exports = __webpack_public_path__ + "static/img/leleqin.cb42020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leleqin.jpg
// module id = XDfr
// module chunks = 1